enum MessengerPostBillingType {
  CARGO = "CARGO",
  TAXI = "TAXI",
}

export default MessengerPostBillingType;
